import _ from 'lodash';
import { convertHelpers } from '../../../../../global/common/convert';
import { creatingHelpers } from '../../../../../global/common/creating';
import { formatItem, formatTypes, getFormattedDate } from '../../../../../global/common/dateFormatting';
import { addIdsToDataItem } from '../../../../../global/firestoreData/appData/ammendData';
import { matchFilterHelpers } from '../../../elements/matches/MatchFilters';
import { matchCalcs } from '../../../helpers/match';
import { _matchSeasonalCollection } from '../SportsSeasonReducer';
import { getDocNormals, getDocSubz, mergeSubData } from './parentKeySportsData';
import { sportsHelpers } from './sportsHelpers';
import { _matchLsTypes } from '../SportsDataReducer';

// const _useNewMethod = true

/**
 * Gets the data for the dataItems (teams, matches, rankings, history, scheduleDates and playoffMatches)
 * @param {object} pathViews 
 * @param {object} dataParents 
 * @param {object} additionalDataParents 
 * @param {string} selectedSeason 
 * @param {function} handleSetDataResults  
 */

// pathViews, dataItems, dataParents, additionalDataParents, sportsKey, selectedSeason, handleSetDataResults, gameScoringType
export const getSportsData_parentKeyCollections = async (sportsOriginType, props) => {

  const {
    dataItems,
    handleSetDataResults,
    sportsKey,
  } = props

  _.forEach(dataItems, (dataItem, dik) => {
    dataItem._dataItemKey = dik
  })

  const dataItems_withSubs = _.pickBy(dataItems, (item) => item.collectionSubs);

  const dns = await getDocNormals({ props })

  const dnss = await Promise.all(
    _.map(dataItems_withSubs, async (dataItem, itemKey) => {
      if (dns[itemKey]) {
        const subData = await getDocSubz({
          props,
          dataItem,
          itemKey: dns[itemKey]._itemKey,
        });
        const _subData = mergeSubData(subData, dataItem)
        return { itemKey, result: _subData, dataItem };
      }
    })
  );

  const subsResults = _.chain(dnss)
    .compact()
    .keyBy('itemKey')
    .mapValues('result')
    .value();

  // 4️⃣ Extract only parentKeys from dns
  const parentDataKeys = _.mapValues(dns, (v) =>
    v && v.parentKeys ? { parentKeys: v.parentKeys } : {}
  );

  // 5️⃣ Combine dns + subsResults + parentKeysOnly, omitting ['id', 'parentKeys', '_itemKey']
  const omitKeys = ['id', 'parentKeys', '_itemKey'];

  const sportsData = _.mapValues(dns, (v, k) => ({
    // base: dns (omitted)
    ..._.omit(v, omitKeys),
    // add: subsResults (omitted)
    ...(_.has(subsResults, k) ? _.omit(subsResults[k], omitKeys) : {}),
  }));
  const _sportsData = {}

  _.forEach(sportsData, (sportsDataItem, sdiKey) => {
    const dataItem = dataItems?.[sdiKey]
    if (dataItem) {
      const { collectionDocField, collectionName, renderAs } = dataItem
      const _collectionName = renderAs ? renderAs : collectionName
      const di = sportsDataItem[_collectionName] ? sportsDataItem[_collectionName] : sportsDataItem
      _sportsData[sdiKey] = di
    }
  })

  handleSetDataResults({ sportsData, parentDataKeys, sportsKey })

}

export const ammend_sportsSeasonDataz = (sportsData, selectedSeason) => {

  // full this object
  const sportsSeason_datas = {}
  //   selectedSeason,
  //   seasonals: {},
  //   matchInfo_seasonal: {},
  //   teams_seasonal: {}
  // }

  _.forEach(sportsData, (sportData, sportDataKey) => {

    let ssdKey = sportDataKey
    let _sportData = sportData

    switch (sportDataKey) {
      case 'seasonMatches':
        ssdKey = 'matchInfo_seasonal'
        _.forEach(sportData, (sportDataItem, sportDataItemKey) => {
          addIdsToDataItem(sportDataItem)
        })
        break;
      case 'playoffs':
        ssdKey = 'playoffTemp'
        break;
      case 'teams_seasonal':
        _sportData = sportData?.teams || sportsData
        addIdsToDataItem(_sportData)
        break;
      case 'teamRecords':
        if (sportsData?.teamRecords) {
          ammendTeamRecords(sportsData.teamRecords)
        }
        break;
    }

    sportsSeason_datas[ssdKey] = _sportData

  })

  return sportsSeason_datas

}

/**
 * 
 * @param {*} data_pure 
 * @param {*} selectedSeason 
 * @returns sportsSeason_datas
 */
export const ammendSportsSeasonDatas = (data_pure, selectedSeason) => {

  // full this object
  const sportsSeason_datas = {
    selectedSeason,
    seasonals: {},
    matchInfo_seasonal: {},
    teams_seasonal: {}
  }

  const sports_refs = {}

  _.forEach(data_pure, (dataItem_pure, key_pure) => {

    // data = the actual data coming from the request 
    const { data, opts } = dataItem_pure
    const { dataItem } = opts ?? {}

    // data is an object consisting of objects 
    const { sub, _refPath, wherez } = opts ?? {}
    const { collectionNamed, collectionName, collectionDocField, docField, docFields, sportPropName, collectionSubs } = dataItem ?? {}

    const _collectionName = sub ? sub : collectionName

    let dataResultName = collectionDocField ? collectionDocField : _collectionName
    let ignoreData = false;

    let _sportPropName = sportPropName ? sportPropName : dataResultName

    // get the data from the field within the document based on the dataResultName 
    let d = data ? data[dataResultName] : {}

    if (sportPropName) {
      if (collectionSubs) {
        switch (key_pure) {
          case 'matches':
          case 'playoffMatches':
            if (data[_collectionName]) {
              convertHelpers.createItemKeys(data[_collectionName])
            }
            break;
          default:
          // nothing
        }
        sportsSeason_datas[sportPropName] = {
          ...sportsSeason_datas[sportPropName] ?? {},
          [key_pure]: data[key_pure]
        };
      } else {
        let _dd;
        if (collectionDocField) {
          _dd = data ? data[collectionDocField] : {}
        } else {
          _dd = data
        }
        const _data = _.omit(_dd, ['id', 'parentKeys', '_itemKey']);
        sportsSeason_datas[sportPropName] = _data
      }
      ignoreData = true
    }

    switch (collectionName) {
      case 'teamRecords':
        // case 'teamRosters':
        if (d) {
          // ammendTeamRecords(d)
        }
    }

    switch (_collectionName) {
      case 'matches_backup':
      case 'matches':
      case 'playoffs':
      case 'teams':
      case 'teams_seasonal':
        addIdsToDataItem(d)
        break;
      default:
      // nothing
    }

    switch (_collectionName) {
      case 'googleLinks':
        if (docFields) {
          ignoreData = true
          docFields.forEach(df => {
            d = data ? data[df] : {}
            // sportsSeason_data[collectionName + '_' + df] = d ?? {}
            sportsSeason_datas[collectionName + '_' + df] = d ?? {}
          })
        } else if (docField) {
          d = data ? data[docField] : {}
          _sportPropName = docField
        }
        break;

      case 'teams':
      case 'staff':
      case 'rosters':
      case 'rankings':
        d = data
        break;

      case 'matches_backup':
      case 'matches':
      case 'matchesNonSection':
      case 'playoffs':
        break;

      case 'schoolsByState':
        d = { schools: data && data.schools ? data.schools : {} }
        break;

      case 'sportsAccess_district':
        d = {
          schools: data && data.schools ? data.schools : {},
          sports: data && data.sports ? data.sports : {},
        }
        break;

      case 'sportsAccess_schools':
        d = { schools: data && data.schools ? data.schools : {} }
        break;

      case 'sportsAccess_teams':
        d = { teams: data && data.teams ? data.teams : {} }
        break;

      default:
      // nothing
    }

    if (collectionNamed) {
      d = data
      _sportPropName = collectionNamed
    }

    if (!ignoreData) {
      if (d && d._itemKey) { delete d._itemKey }
      // sportsSeason_data[_sportPropName] = d ?? {}
      sportsSeason_datas[_sportPropName] = d ?? {}
      sports_refs[_sportPropName] = { _refPath, wherez }
    }
  })

  return sportsSeason_datas

}

export const ammendMatchesAndTeams = (
  matchInfo,
  teams_seasonal,
  teams_info,
  gameScoringType,
  _getScoresFromScores,
  levelLatestStartDates,
  startHour,
  _sportsModeSport,
  _rankings,
  sectionPlayoffTeams,
) => {

  const { matches, matches_playoffs, scores, playoffScores, playoffMatches_backup } = matchInfo ?? {}

  let _teamsFromMatches;

  // MATCHES
  if (matches && teams_seasonal && _.isEmpty(teams_seasonal)) {
    _teamsFromMatches = getTeamsFromMatches(matches)
  }

  if (_getScoresFromScores) {
    sportsHelpers.ammendScoresWithScores(matches, scores)
    sportsHelpers.ammendScoresWithScores(matches_playoffs, playoffScores)
  }

  // calc the matches
  if (matches) { matchCalcs.calcAllVballMatches(matches, gameScoringType) }
  if (matches_playoffs) { matchCalcs.calcAllVballMatches(matches_playoffs, gameScoringType) }

  const _lMatches = matches_playoffs ? { ...matches, ...matches_playoffs } : matches

  const upcomingMatchDate = new Date()
  // const levelUpcomingMatches = getUpcomingMatches(_lMatches, upcomingMatchDate)

  const ssi = teams_seasonal && matches ? sportsHelpers.ammendTeams(teams_seasonal, matches, _rankings, _sportsModeSport, sectionPlayoffTeams) : null

  const { sportLevels, teams } = ssi ?? {}
  convertHelpers.createItemKeys(teams)

  getTeamDeets(teams, matches)

  sportsHelpers.ammendMatchTeamNames(matches, teams)
  sportsHelpers.ammendMatchTeamNames(matches_playoffs, teams, true)

  const matchesTeams = {}

  const amm = sportsHelpers.ammendMatchesInfo(matches, matches_playoffs)

  if (amm.matches) {

    if (teams) {
      Object.keys(teams).forEach(tk => {
        const tms = _.filter(amm.matches, function (m) { return m.teams && m.teams.includes(tk); })
        const today = new Date();
        const _next = _.takeRight(_.filter(_.orderBy(tms, ['startDate'], ['desc']), item => new Date(item.startDate).setHours(startHour, 0, 0, 0) >= today), 1);
        const _latest = _.takeRight(_.filter(_.orderBy(tms, ['startDate'], ['asc']), item => (item.results && item.results.complete === true) && new Date(item.startDate).setHours(startHour, 0, 0, 0) < today), 5);
        matchesTeams[tk] = {
          all: tms,
          next: _next,
          latest: _latest
        }
      })
    }
  }

  const levelVisibleDates = {}

  if (levelLatestStartDates) {
    _.forEach(levelLatestStartDates, (lld, lk) => {
      levelVisibleDates[lk] = [lld]
    })
  }

  const { sportTeams } = teams_info ?? {}

  setTeamsNextMatch(amm, teams, matches)
  createTeamInitials(teams, sportTeams)

  const _matchPlayoffPendings = matchFilterHelpers.getPendingMatches({ matches_playoffs: amm.matches_playoffs })

  const matches_info = {
    matches_groupInfo: matchInfo,
    // levelUpcomingMatches,
    levelVisibleDates,
    matches: amm.matches,
    matches_combined: matches_playoffs ? { ...amm.matches, ...matches_playoffs } : amm.matches,
    matchesRetrieved: true,
    matchPlayoffPendings: _matchPlayoffPendings,
    playoffMatches_backup: playoffMatches_backup ?? {},
    matches_playoffs: amm.matches_playoffs,
    playoffScores: playoffScores,
    scores: scores,
  }

  return { matches_info, _teamsFromMatches, upcomingMatchDate, amm, ssi }
}

const setTeamsNextMatch = (amm, teams, matches) => {
  if (teams && matches) {
    _.forEach(teams, (team, teamKey) => {
      const nm = matchFilterHelpers.getNextMatch(amm.matches, teamKey)
      team._nextMatch = nm
    })
  }

}

const createTeamInitials = (teams, sportTeams) => {
  if (teams && sportTeams) {
    _.forEach(sportTeams, (sportTeam, stk) => {
      const _team = teams[stk]
      if (_team) {
        const { name: name_team } = _team ?? {}
        const { initials, name: name_sportTeam } = sportTeam
        if (initials) {
          teams[stk].initials = sportTeam.initials
        }
        if (name_team !== name_sportTeam) {
          console.log('******* BAD NAME ************', name_team, name_sportTeam)
        }
      }
    })
  }
}

/**
 * 
 * @param {*} matchInfo_seasonal (matches, matches_playoffs)
 * @param {*} selectedSeason 
 * @returns 
 */
export const getMatches_groupInfo = (matchInfo_seasonal, selectedSeason, _deletedTeams, appUserAccess) => {

  const { matches } = matchInfo_seasonal ?? {}

  const matches_groupInfo = {
    levelDateGroups: null,
    levelLatestStartDates: null,
    levelMatches: null,
    matchDateGroups: null,
    matches_combined: null,
    playoffTournaments: null,
  }

  if (matches) {

    const seasonMatches = getAllMatches(matchInfo_seasonal, _deletedTeams)

    const {
      _allMatches,
      _matches,
      _matches_playoffs,
      _dateGroups,
      _levelMatches,
      _levelDateGroups,
      _levelLatestStartDates,
      _levelLastStartDates,
    } = seasonMatches

    const { matchDateKeys, matchDateKeys_count } = matchFilterHelpers.getMatchDateKeys(_dateGroups)

    matches_groupInfo.matches_combined = _allMatches
    matches_groupInfo.matches = _matches
    matches_groupInfo.matches_playoffs = _matches_playoffs
    matches_groupInfo.matchDateGroups = _dateGroups
    matches_groupInfo.matchDateKeys = matchDateKeys
    matches_groupInfo.matchDateKeys_count = matchDateKeys_count
    matches_groupInfo.levelMatches = _levelMatches
    matches_groupInfo.levelKeys = _.difference(_.reverse(_.keys(_levelMatches)), [_matchLsTypes.nonSection, _matchLsTypes.nonLevel, _matchLsTypes.tournament]);
    matches_groupInfo.levelDateGroups = _levelDateGroups
    matches_groupInfo.levelLatestStartDates = _levelLatestStartDates
    matches_groupInfo.levelLastStartDates = _levelLastStartDates
    matches_groupInfo.playoffTournaments = createPlayoffTournaments(_matches_playoffs)
    matches_groupInfo.selectedSeason = selectedSeason
    const { levelSectionDateMatches, scheduleLevelKeys } = getLSMD(_matches)
    matches_groupInfo.levelSectionDateMatches = levelSectionDateMatches
    matches_groupInfo.scheduleLevelKeys = scheduleLevelKeys
    // console.log('matches_groupInfo', matches_groupInfo)
  }


  return matches_groupInfo

}

const dateToTimestamp = (dateStr) => {
  const [month, day, year] = dateStr.split('/').map(Number);
  return new Date(year, month - 1, day).getTime();
};

// const getDRS = (dataItems_sportsSeason, sportsSeason_datas) => {

//   const drs = {}

//   _.forEach(dataItems_sportsSeason, (dataItem, dataItemKey) => {
//     const { collectionName, collectionDocField, collectionSubs } = dataItem ?? {}
//     switch (collectionName) {
//       case _matchSeasonalCollection:
//         if (collectionSubs) {
//           _.forEach(collectionSubs, (collectionSub) => {
//             drs[collectionSub] = sportsSeason_datas[collectionSub]
//           })
//         }
//         break;
//       default:
//         if (collectionDocField) {
//           drs[collectionDocField] = sportsSeason_data[collectionDocField]
//         } else if (sportsSeason_datas[collectionName]) {
//           drs[dataItemKey] = sportsSeason_datas[dataItemKey]
//         }
//     }
//   })

//   return drs
// }

const ammendTeamRecords = (teamRecords) => {

  try {
    // Function to calculate win percentage
    const calculateWinPercentage = (record) => {
      const [wins, losses] = record.split('-').map(Number);
      return (wins / (wins + losses)).toFixed(2); // Limit to 2 decimals
    };

    // Group teams by year, level, and section
    const groupedTeams = _.reduce(teamRecords, (result, team) => {
      _.forEach(team.records, (yearRecord, year) => {
        const { level, section, record } = yearRecord;
        const winPercentage = calculateWinPercentage(record);

        if (!result[year]) result[year] = {};
        if (!result[year][level]) result[year][level] = {};
        if (!result[year][level][section]) result[year][level][section] = [];

        result[year][level][section].push({
          teamName: team.name,
          winPercentage: parseFloat(winPercentage), // Store as float for later sorting
          record,
          yearRecord
        });
      });
      return result;
    }, {});

    // Helper function to get ordinal suffix (1st, 2nd, 3rd, etc.)
    const getOrdinalSuffix = (num) => {
      const suffix = ['th', 'st', 'nd', 'rd'];
      const value = num % 100;
      return suffix[(value - 20) % 10] || suffix[value] || suffix[0];
    };

    // Sort the teams by win percentage within each section and add position
    const sortedGroupedTeams = _.mapValues(groupedTeams, (levels) => {
      return _.mapValues(levels, (sections) => {
        return _.mapValues(sections, (teams) => {
          // Sort teams by winPercentage (descending order)
          const sortedTeams = _.orderBy(teams, ['winPercentage'], ['desc']);

          // Assign position (1st, 2nd, 3rd, etc.)
          const totalTeams = sortedTeams.length;
          return sortedTeams.map((team, index) => {
            const { yearRecord } = team;

            // Add position and winPercentage to the original yearRecord
            yearRecord.winPercentage = team.winPercentage;
            yearRecord.position = `${index + 1}${getOrdinalSuffix(index + 1)}`;
            yearRecord.totalTeams = totalTeams;
            yearRecord.rank = yearRecord.position + ' of ' + totalTeams

            return yearRecord;
          });
        });
      });
    });

    // Apply changes to the original teamRecords with the updated yearRecord
    _.forEach(teamRecords, (team) => {
      _.forEach(team.records, (yearRecord, year) => {
        const updatedYearRecord = sortedGroupedTeams[year]?.[yearRecord.level]?.[yearRecord.section]?.find(t => t.teamName === team.name);
        if (updatedYearRecord) {
          // Update the original team records with win percentage and position
          team.records[year] = {
            ...yearRecord,
            winPercentage: updatedYearRecord.winPercentage,
            position: updatedYearRecord.position,
            totalTeams: updatedYearRecord.totalTeams,
          };
        }
      });
    });

    return sortedGroupedTeams
  } catch (error) {
    return {}
  }

}

// v2.6.5.30360
// v2.6.5.30360
// FablesofthePhil5

/**
 * 
 * @param {*} matchInfo_seasonal (matches, playoffMatches)
 * @returns 
 */
const getAllMatches = (matchInfo_seasonal, _deletedTeams) => {
  // matches_playoffs is coming from it's own collection 
  const { matches, playoffMatches, playoffScores, scores } = matchInfo_seasonal

  // matchInfo_seasonal => matches, playoffMatches... 

  const dts = _deletedTeams ? _deletedTeams : ['K9IBDjd0zcPUiSB6fjXG']
  const filteredMatches = _.pickBy(matches, match => {
    return !dts.includes(match?.home?.id) && !dts.includes(match?.away?.id);
  });

  if (filteredMatches) {
    let _matches = filteredMatches
    let _allMatches = filteredMatches
    const _playoffMatchesFromMatches = matchFilterHelpers.getPlayoffMatches(_matches)
    const matches_playoffs = !_.isEmpty(playoffMatches) ? playoffMatches : _playoffMatchesFromMatches
    if (!_.isEmpty(matches_playoffs)) { _allMatches = { ...filteredMatches, ...matches_playoffs } }

    const {
      levelMatchDateGroups: _dateGroups,
      levelLatestStartDates: _levelLatestStartDates,
      levelLastStartDates: _levelLastStartDates,
    } = matchFilterHelpers.getLevelMatchDateGroups(_allMatches)

    const { _levelMatches, _levelDateGroups } = getLevelMatchez(_allMatches)

    return {
      _allMatches,
      _matches,
      _matches_playoffs: matches_playoffs,
      _dateGroups,
      _levelMatches,
      _levelDateGroups,
      _levelLatestStartDates,
      _levelLastStartDates
    }
  }
}


export const getLevelMatchez = (matches, forUpdate) => {

  convertHelpers.createItemKeys(matches)

  // Group the matches by 'levels'
  const matches_groupedByLevel = _.groupBy(matches, 'levels');

  const _levelMatches = {};
  const _levelDateGroups = {};
  const _levelUpdateMatches = {}

  // Function to handle nonDistrict and Non groups to filter home and away matches
  const addGroupMatches = (groupKey, levelKey, matches_groupedByLevel, matches_level) => {
    if (_.has(matches_groupedByLevel, groupKey)) {
      const matches_home = _.filter(matches_groupedByLevel[groupKey], m => m.home?.levels === levelKey);
      const matches_away = _.filter(matches_groupedByLevel[groupKey], m => m.away?.levels === levelKey);
      return _.concat(matches_level, matches_home, matches_away);
    }
    return matches_level;
  };

  if (matches_groupedByLevel) {
    // Iterate through each level
    _.forEach(matches_groupedByLevel, (matches_level, levelKey) => {

      // Add matches from Non and nonDistrict groups dynamically
      matches_level = addGroupMatches(_matchLsTypes.Non, levelKey, matches_groupedByLevel, matches_level);
      matches_level = addGroupMatches(_matchLsTypes.nonDistrict, levelKey, matches_groupedByLevel, matches_level);

      // Create the _itemKeys for the level matches
      const _groupMatches = creatingHelpers.createKeyedObjectFromKey(matches_level, null, '_itemKey');
      _levelMatches[levelKey] = _groupMatches;
      _levelUpdateMatches[levelKey] = ammendMatchForUpdate(_groupMatches);
      // Generate date groups for each level using Lodash to group by date 
      _levelDateGroups[levelKey] = matchFilterHelpers.getSingleLevelMatchDateGroups(_groupMatches);
    });
  }

  return { _levelMatches, _levelDateGroups, _levelUpdateMatches };
};

const ammendMatchForUpdate = (matches) => {
  const _matches = {}
  _.forEach(matches, (match) => {
    const { _itemKey, isPlayoff } = match
    const prefix = isPlayoff ? 'playoffMatches' : 'matches'
    _matches[prefix + '.' + _itemKey] = match
  })
  return _matches
}

const getAllTeamItems = (datas, itemType, itemPropType) => {
  const _items = {}
  const { teams } = datas
  const _data = datas[itemType]
  if (teams && _data) {
    Object.keys(teams).forEach(tk => {
      const xxx = _.filter(_data, function (item) {
        return (item && item.parentKeys && item.parentKeys.teams === tk);
      })
      if (xxx && xxx.length === 1) {
        _items[tk] = xxx[0][itemPropType]
      }
    })
  }
  return _items
}

const createPlayoffTournaments = (matches_playoffs) => {
  const ts = []
  const levelMatches = _.groupBy(matches_playoffs, 'levels')
  if (levelMatches) {
    Object.keys(levelMatches).forEach(levelKey => {
      ts[levelKey] = { rounds: { playoffs: { itemKey: 'playoffs', pools: {} } } }
      const lm = levelMatches[levelKey]
      const poolMatches = _.groupBy(lm, 'poolKey')
      Object.keys(poolMatches).forEach(poolKey => {
        ts[levelKey].rounds.playoffs.pools[poolKey] = {
          poolKey: poolKey,
          matches: mz(poolMatches[poolKey])
        }
      })
    })
  }
  return ts
}

const mz = (matches) => {
  const ms = {}
  matches.forEach(m => {
    ms['match' + m.matchNumber] = m
  })
  return ms
}

export const getLevelsDeets = (matches) => {
  // Create a map of teams by _itemKey
  const levelsMap = _.keyBy(matches, 'levels');
  console.log(levelsMap);

}

export const getTeamDeets = (teams, matches) => {
  // Create a map of teams by _itemKey
  const teamsMap = _.keyBy(teams, '_itemKey');

  // Initialize an object to hold matches by team
  const matchesByTeam = _.mapValues(teamsMap, team => ({
    ...team,
    matches: []
  }));

  // Populate the matches array
  _.forEach(matches, (match) => {
    const { home, away } = match;

    if (home?.id && matchesByTeam[home.id]) {
      matchesByTeam[home.id].matches.push(match._itemKey);
    }

    if (away?.id && matchesByTeam[away.id]) {
      matchesByTeam[away.id].matches.push(match._itemKey);
    }
  });

}

export const getMatchDeets = (matches) => {

  // Group matches by matchCollectionKey 
  const matchesByLevels = _.groupBy(matches, '_matchCollectionKey');
  const matchesByStartDate = _.groupBy(matches, 'startDate');

  const formatDate = (date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  };

  // Today's date as mm/dd/yyyy
  const today = formatDate(new Date());

  // Process each startDate group
  const result = _.mapValues(matchesByStartDate, (matchesForStartDate, startDate) => {
    // Group by _matchCollectionKey within each startDate
    const matchesByCollection = _.groupBy(matchesForStartDate, '_matchCollectionKey');

    // Map over each _matchCollectionKey group to build the final structure
    return _.mapValues(matchesByCollection, (matches, mcKey) => {

      const matchKeys = matches.map(({ _itemKey }) => _itemKey); // Only store match keys
      const matchDates = matches.map(({ startDate }) => startDate).sort((a, b) => new Date(a) - new Date(b));

      // Calculate first match date
      const firstMatchDate = matchDates[0];

      // Calculate next match date
      const upcomingDates = matchDates.filter(date => new Date(date) > new Date(today));
      const nextMatchDate = matches.some(({ startDate }) => startDate === today)
        ? today
        : upcomingDates[0] || 'Off Season';

      // Calculate match count, offSeason, and additional props
      const matchCount = matches.length;
      const offSeason = nextMatchDate === 'Off Season';
      const hasMatches = matches.length > 0;
      const todaysMatchCount = hasMatches ? matchCount : 0;
      const caption = hasMatches ? `${matchCount} matches` : 'No matches';
      const subCaption = hasMatches ? '' : `Next match ${formatItem('fullDate', startDate)}.`;

      if (startDate === today) {
        return {
          matches: matchKeys,
          matchCount,
          firstMatchDate,
          nextMatchDate,
          offSeason,
          hasMatches,
          todaysMatchCount,
          caption,
          subCaption,
        };
      } else {
        return {
          matches: matchKeys,
          matchCount,
          hasMatches,
        };
      }
    });
  });

  return result

}

export const getUpcomingMatches = (matches, upcomingMatchDate) => {

  const _today = getFormattedDate(upcomingMatchDate)

  const matches_level = _.groupBy(matches, 'levels')

  const filterMatchesByStartDate = (group, formattedMatchDate) => _.filter(group, match => match.startDate === formattedMatchDate && !match?._status?.isBye);

  const _lums = {}

  _.forEach(matches_level, (matches, level) => {
    if (level !== 'undefined') {
      const dateLimits = getMatchDateLimits(matches)

      let _startDate = new Date(upcomingMatchDate);
      _startDate.setHours(0, 0, 0, 0);

      let _startDateFound;
      let filteredMatches = [];
      let selectedMatches = [];
      let iterations = 0;

      if (dateLimits.latestStartDate >= _startDate) {
        // Continue searching until you find matches with a non-zero count
        while (filteredMatches.length === 0 && iterations < 80) {
          const formattedMatchDate = getFormattedDate(_startDate)
          _startDateFound = formattedMatchDate
          filteredMatches = filterMatchesByStartDate(matches_level[level], formattedMatchDate);
          _startDate.setDate(_startDate.getDate() + 1); // Move to the next day
        }
        selectedMatches = selectedMatches.concat(filteredMatches);
        _lums[level] = {
          matches: filteredMatches,
          startDate: _startDateFound,
          level
        }
      } else {
        _lums[level] = {
          matches: [],
          offSeason: true,
          level
        }
      }
    }
  })


  _.forEach(_lums, (lms, lk) => {

    const { startDate, matches, offSeason } = lms

    _lums[lk].offSeason = offSeason
    _lums[lk].hasMatches = startDate === _today ? true : false
    _lums[lk].matchCount = startDate === _today ? matches.length : 0
    _lums[lk].caption = startDate === _today ? matches.length + ' matches' : 'No matches'
    _lums[lk].subCaption = startDate === _today ? '' : 'Next match ' + formatItem(formatTypes.fullDate, startDate) + '.'
    if (offSeason) {
      _lums[lk].subCaption = 'No Matches Scheduled'
    }
    switch (true) {
      case matchCalcs.isNon(lk):
        _lums[lk].hide = _lums[lk].matchCount === 0 ? true : false
    }
  })

  return _lums

}


const getMatchDateLimits = (matches) => {
  // Initialize variables to hold the earliest and latest startDate
  let earliestStartDate = null;
  let latestStartDate = null;

  // Iterate through the list of matches
  matches.forEach(match => {
    const matchStartDate = new Date(match.startDate);

    // Update earliestStartDate and latestStartDate
    if (earliestStartDate === null || matchStartDate < earliestStartDate) {
      earliestStartDate = matchStartDate;
    }

    if (latestStartDate === null || matchStartDate > latestStartDate) {
      latestStartDate = matchStartDate;
    }
  });

  return { earliestStartDate, latestStartDate }
}

const getDataSizes = (sportsSeason_datas, matches_data) => {

  const jsonDatas = {
    sports: JSON.stringify(sportsSeason_datas),
    matches: JSON.stringify(matches_data),
  }

  const sizes = {
    sports: new Blob([jsonDatas.sports]).size,
    matches: new Blob([jsonDatas.matches]).size,
  }

}

const getTeamsFromMatches = (matches) => {

  const groupedMatches = _.groupBy(matches, match => `${match.home.levels}-${match.home.sections}`);

  const allTeams = {}

  Object.keys(groupedMatches).forEach(gt => {
    const groupMatches = groupedMatches[gt]
    const sss = _.groupBy(groupMatches, match => `${match.home.id}`);
    Object.keys(sss).forEach(teamKey => {
      const ms = sss[teamKey] // array
      ms.forEach(m => {
        const { home } = m
        if (home.id && !allTeams[teamKey]) {
          allTeams[teamKey] = {
            _itemKey: home.id,
            name: home.name,
            id: home.id,
            levels: home.levels,
            sections: home.sections,
            record: {}
          }
        }
      })
    })
  })

  return allTeams

}

const getLSMD = (matches) => {

  // Step 1: group by _matchCollectionKey (or 'levels')
  const groupedByLevel = _.groupBy(matches, '_matchCollectionKey');

  // Step 2: for each level, group by startDate and sort chronologically
  const matches_byLevel = _.mapValues(groupedByLevel, (levelGroup) => {

    // group by startDate
    const groupedByDate = _.groupBy(levelGroup, 'startDate');

    // sort the dates
    const sortedByDate = {};
    _.keys(groupedByDate) // using _.keys here
      .sort((a, b) => dateToTimestamp(a) - dateToTimestamp(b))
      .forEach((date) => {
        // group by sections within each date
        const _matches = _.groupBy(groupedByDate[date], 'sections');
        sortedByDate[date] = _matches
      });

    return sortedByDate;
  });


  const matches_added = []

  _.forEach(matches_byLevel, (matches_level, levelKey) => {
    switch (levelKey) {
      case 'Non':
      case 'nonDistrict':
        _.forEach(matches_level, (groupedMatches, groupDateKey) => {
          _.forEach(groupedMatches, (dateMatches, dataMatchKey) => {
            _.forEach(dateMatches, (match) => {
              const { home, away, _itemKey: matchKey } = match;
              const level_home = home?.levels;
              const level_away = away?.levels;

              if (level_home && !_.includes(matches_added, matchKey)) {
                _.update(
                  matches_byLevel,
                  [level_home, groupDateKey, dataMatchKey],
                  (arr = []) => {
                    arr.push(match);
                    return arr;
                  }
                );
                matches_added.push(matchKey)
              }

              if (level_away && !_.includes(matches_added, matchKey)) {
                _.update(
                  matches_byLevel,
                  [level_away, groupDateKey, dataMatchKey],
                  (arr = []) => {
                    arr.push(match);
                    return arr;
                  }
                );
                matches_added.push(matchKey)
              }
            });
          });
        });
    }
  });

  return { levelSectionDateMatches: matches_byLevel, scheduleLevelKeys: _.keys(matches_byLevel) }

}